import {Select, MenuItem, FormControl, InputLabel, FormHelperText} from "@mui/material";
import {useState} from "react";

const ErrorHandlingSelect = ({validators, onValChange, check, options, label, ...rest}) => {
    const [error, setError] = useState('')

    const validate = (val) => {
        setError('')
        for (let validator of validators) {
            const validatedResult = validator(val)
            if (!validatedResult.result) {
                if (check) check(true)
                return setError(validatedResult.error)
            }
        }
        if (check) check(false)
    }

    return (
        <FormControl fullWidth error={Boolean(error)}>
            <InputLabel>{label}</InputLabel>
            <Select
                label={label}
                {...rest}
                onChange={e => {
                    onValChange(e)
                    validate(e.target.value)
                }}
            >
                {options.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    )
}

export default ErrorHandlingSelect 